import { auth } from './firebase'

export async function getAuthToken() {
  if (auth.currentUser) {
    return await auth.currentUser.getIdToken()
  }
  return null
}

export function getAuthHeader() {
  return {
    'Content-Type': 'application/json',
    // El token se agregará dinámicamente en las llamadas
  }
}

export async function fetchWithAuth(url, options = {}) {
  const token = await getAuthToken()
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  return fetch(url, {
    ...options,
    headers,
  })
}
